/* eslint-disable react/jsx-no-undef */
// /* eslint-disable no-unused-vars */
import React, { Component, Suspense } from "react";
import { connect } from "react-redux";
import { cloneDeep } from "lodash";

// Components Imports
// import AddComponents from "./AddComponents";
// import CoverpageThemes from "./CoverpageThemes";
// import CutomizeCoverpagePane from "./CutomizeCoverpagePane";
// import StripePaymentListPane from "./StripePaymentListPane";
// import TableFormulaPane from "./TableFormulaPane";
import { LazyLoad } from "../../commonComponents";

import {
  addComponentInDocument,
  updateDraggedSection,
  updateDocumentSectionAction,
  toggleCoverpageView,
  coverpageThemeAction,
  addDocumentComponentAction,
  updateDocumentComponentAction,
  updateDocumentClickedComponentID,
  executeCommand,
  removeComponentInDocument,
  undoComponentUpdate,
  forceUpdateEditorSectionIdAction,
  updateActiveComponentMeta,
  updatePageBreakScrollViewAction,
  autoUpdateTitle,
} from "../../actions/DocumentActions";
import { QuotationActions, ToolbarActions } from "../../actions";

import { nukeActiveEditor } from "../../actions/EditorActions/editorActions";

// Import services
import {
  addDocumentComponentService,
  updateDocumentComponentService,
  uploadImageService,
} from "../../actions/DocumentActions/services";

// import services
import {
  addTemplateComponentService,
  updateTemplateComponentService,
} from "../../actions/DocumentTemplateActions/templateService";

import { PIPELINE, COVERPAGETEMPLATES } from "../../constants";
import { DOCUMENT_COMPONENT_TYPES } from "../../constants/document";

// Utility Imports
// import { GlobalUtils } from "../../utils/index";
// import { getContentForComponent } from "../../utils/documentUtils";

import AddComponentCommand from "../../commands/addComponentCommand";
import UpdateComponentCommand from "../../commands/updateComponentCommand";
import PageNumberListPane from "../PageNumber/PageNumberListPane";

// Lazy loading imports
const AddComponentsLazy = LazyLoad(() =>
  import(/* webpackChunkName: "add-components" */ "./AddComponents"),
);
const CoverpageThemesLazy = LazyLoad(() =>
  import(/* webpackChunkName: "coverpage-themes" */ "./CoverpageThemes"),
);
const CutomizeCoverpagePaneLazy = LazyLoad(() =>
  import(
    /* webpackChunkName: "customize-coverpage-pane" */ "./CutomizeCoverpagePane"
  ),
);
const StripePaymentListPaneLazy = LazyLoad(() =>
  import(
    /* webpackChunkName: "stripe-paymentlist-pane" */ "./StripePaymentListPane"
  ),
);
const TableFormulaPaneLazy = LazyLoad(() =>
  import(/* webpackChunkName: "table-formula-pane" */ "./TableFormulaPane"),
);

// DESTRUCTURING
const { addDealTableTab, updateToolPaneData } = QuotationActions;
const { DOCUMENT_STATUS_HASMAP } = PIPELINE;
const { THEME_THUMBNAILS } = COVERPAGETEMPLATES;
const { updateAddComponentinToolbarAction } = ToolbarActions;

// Declaration
const DOCUMENT = "DOCUMENT";
const TEMPLATE = "TEMPLATE";
const FORM = "FORM";

class DocumentComponents extends Component {
  componentWillUnmount = () => {
    if (
      this.props.addComponentType !== DOCUMENT_COMPONENT_TYPES.HEADER_FOOTER
    ) {
      this.props.updateAddComponentinToolbarAction(null);
    }
    if (this.props.coverpageThemeActionData === "ApplyTableFormula") {
      this.props.updateToolPaneData(false, "");
    }
    this.props.coverpageThemeAction(null);
  };

  _checkEditableCoverpage = () => {
    const { coverpage } = this.props;
    if (coverpage && coverpage.data && !coverpage.lock) return true;
    return false;
  };

  _getPaneView = () => {
    const { coverpage, appliedCoverpageTheme } = this.props;
    let paneView = null;
    if (
      this.props.coverpageThemeActionData === "OpenThemePane" &&
      this._checkEditableCoverpage()
    ) {
      paneView = (
        <Suspense fallback="">
          <CoverpageThemesLazy
            sectionData={coverpage.data.attributes}
            closeCoverpageThemePane={this._closeCoverpageThemePane}
            toggleCoverpageThemePane={this.props.coverpageThemeAction}
            changeCoverpageTheme={this._changeCoverpageTheme}
            appliedTheme={appliedCoverpageTheme}
          />
        </Suspense>
      );
    } else if (
      this.props.coverpageThemeActionData === "OpenCustomizationPane" &&
      this._checkEditableCoverpage()
    ) {
      paneView = (
        <Suspense fallback="">
          <CutomizeCoverpagePaneLazy
            sectionData={coverpage.data.attributes}
            toggleCustomizeCoverpagePane={this.props.coverpageThemeAction}
            changeCoverpageColorOpacity={this._changeCoverpageColorOpacity}
            changeCoverpageImageOpacity={this._changeCoverpageImageOpacity}
            changeBackgroundColor={this._changeBackgroundColor}
            changeBackgroundImage={this._changeBackgroundImage}
            removeBackgroundImage={this._removeBackgroundImage}
            changeBackgroundImagePosition={this._changeBackgroundImagePosition}
            resetTheme={this._resetTheme}
            uploadImageService={uploadImageService}
            closeCoverpageThemePane={this._closeCoverpageThemePane}
          />
        </Suspense>
      );
    } else if (this.props.coverpageThemeActionData === "ApplyTableFormula") {
      paneView = (
        <Suspense fallback="">
          <TableFormulaPaneLazy
            data={this.props}
            section={this.props.activeComponent}
            updateSection={this._updateComponent}
            closeCoverpageThemePane={this._closeCoverpageThemePane}
          />
        </Suspense>
      );
    }

    return paneView;
  };

  _deleteColorAttr = coverpageSec => {
    const { color } = coverpageSec.data.attributes;
    if (color) {
      delete coverpageSec.data.attributes.color;
    }
    return coverpageSec;
  };

  _updateBackgroundAttr = coverpageSec => {
    const { color, background } = coverpageSec.data.attributes;
    if (color && background === "0404e2") {
      coverpageSec.data.attributes.background = "#fff";
      delete coverpageSec.data.attributes.color;
    }
    return coverpageSec;
  };

  _changeCoverpageTheme = theme => {
    if (theme.appliedTheme !== this.props.appliedCoverpageTheme) {
      const { coverpage } = this.props;
      const element = coverpage ? document.getElementById(coverpage.id) : null;
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
      let updatedSection = cloneDeep(coverpage);
      const oldSection = cloneDeep(coverpage);
      updatedSection = this._deleteColorAttr(updatedSection);
      updatedSection.data.attributes = {
        ...updatedSection.data.attributes,
        ...theme,
      };
      this._updateComponent(updatedSection, undefined, false, oldSection);
    }
  };

  _closeCoverpageThemePane = () => {
    this.props.coverpageThemeAction(null);
    const disableEdit =
      this.props.isDocumentLocked ||
      (this.props.isTemplateTypeForm && this.props.showForm);
    if (disableEdit) this.props.updateToolPaneData(false, "");
  };

  _resetTheme = () => {
    const { appliedCoverpageTheme } = this.props;
    const { coverpage } = this.props;
    let updatedSection = cloneDeep(coverpage);
    const oldSection = cloneDeep(coverpage);
    updatedSection = this._deleteColorAttr(updatedSection);
    const themeData = THEME_THUMBNAILS.filter(
      theme => appliedCoverpageTheme === theme.label,
    );
    if (!appliedCoverpageTheme && themeData.length === 0) {
      const data = THEME_THUMBNAILS.filter(theme => theme.label === "Default");
      updatedSection.data.attributes = {
        ...updatedSection.data.attributes,
        ...data[0].data,
      };
      this._updateComponent(updatedSection, undefined, false, oldSection);
      this.props.coverpageThemeAction("OpenThemePane");
    } else if (
      JSON.stringify(themeData[0].data) !==
      JSON.stringify(updatedSection.data.attributes)
    ) {
      updatedSection.data.attributes = {
        ...updatedSection.data.attributes,
        ...themeData[0].data,
      };
      this._updateComponent(updatedSection, undefined, false, oldSection);
      this.props.coverpageThemeAction("OpenThemePane");
    }
  };

  _changeCoverpageColorOpacity = alphaValue => {
    const { coverpage } = this.props;
    let updatedSection = cloneDeep(coverpage);
    const oldSection = cloneDeep(coverpage);
    updatedSection = this._updateBackgroundAttr(updatedSection);
    updatedSection.data.attributes = {
      ...updatedSection.data.attributes,
      colorTransparency: alphaValue,
    };
    this._updateComponent(updatedSection, undefined, false, oldSection);
  };

  _changeCoverpageImageOpacity = alphaValue => {
    const { coverpage } = this.props;
    let updatedSection = cloneDeep(coverpage);
    const oldSection = cloneDeep(coverpage);
    updatedSection = this._updateBackgroundAttr(updatedSection);
    updatedSection.data.attributes = {
      ...updatedSection.data.attributes,
      imageTransparency: alphaValue,
    };
    this._updateComponent(updatedSection, undefined, false, oldSection);
  };

  _changeBackgroundColor = newColor => {
    let { coverpage } = this.props;
    coverpage = this._deleteColorAttr(coverpage);
    const updatedSection = cloneDeep(coverpage);
    const oldSection = cloneDeep(coverpage);
    updatedSection.data.attributes = {
      ...updatedSection.data.attributes,
      background: newColor,
    };
    this._updateComponent(updatedSection, undefined, false, oldSection);
  };

  _changeBackgroundImage = (imageURL, altTextData) => {
    let { coverpage } = this.props;
    coverpage = this._updateBackgroundAttr(coverpage);
    const updatedSection = cloneDeep(coverpage);
    const oldSection = cloneDeep(coverpage);
    updatedSection.data.attributes = {
      ...updatedSection.data.attributes,
      backgroundImage: imageURL,
      altText: altTextData,
    };
    this._updateComponent(updatedSection, undefined, false, oldSection);
  };

  _changeBackgroundImagePosition = position => {
    const { coverpage } = this.props;
    let updatedSection = cloneDeep(coverpage);
    const oldSection = cloneDeep(coverpage);
    updatedSection = this._updateBackgroundAttr(updatedSection);
    updatedSection.data.attributes = {
      ...updatedSection.data.attributes,
      imagePosition: position,
    };
    this._updateComponent(updatedSection, undefined, false, oldSection);
  };

  _removeBackgroundImage = () => {
    const { coverpage } = this.props;
    let updatedSection = cloneDeep(coverpage);
    const oldSection = cloneDeep(coverpage);
    updatedSection = this._deleteColorAttr(updatedSection);
    updatedSection.data.attributes = {
      ...updatedSection.data.attributes,
      backgroundImage: "",
    };
    this._updateComponent(updatedSection, undefined, false, oldSection);
  };

  _removeActiveComponents = () => {
    const oldComponents = document.getElementsByClassName("active-component");
    for (let i = 0; i < oldComponents.length; i += 1) {
      oldComponents[i].classList.remove("active-component");
    }
  };

  _getComponentService = type => {
    const { mode } = this.props;
    if (type === "ADD") {
      if (mode === DOCUMENT) return addDocumentComponentService;
      if (mode === TEMPLATE) return addTemplateComponentService;
    } else if (type === "UPDATE") {
      if (mode === DOCUMENT) return updateDocumentComponentService;
      if (mode === TEMPLATE) return updateTemplateComponentService;
    }
    return null;
  };

  _addComponentPane = () => {
    const {
      mode,
      showDocumentDiffView,
      isDocumentLocked,
      isTemplateTypeForm,
      addComponentType,
      showForm,
    } = this.props;
    const disableEdit = isDocumentLocked || (isTemplateTypeForm && showForm);

    // if edit is not allowed, add components pane should not open
    if (disableEdit) return null;

    return (
      <div className="context-notes  animated fadeinright">
        <div className="notes-header">
          <span
            data-test="notesheader-right-pane-title"
            className="right-pane-title">
            Document blocks
          </span>
        </div>
        <div className="notes-container">
          <Suspense fallback="">
            <AddComponentsLazy
              mode={mode}
              updateSection={this._updateComponent}
              addNewComponent={this._addNewComponent}
              setDraggedSection={this.props.updateDraggedSection}
              showDocumentDiffView={showDocumentDiffView}
              disableEdit={disableEdit}
              showEditPane={this._showEditPane}
              addComponentType={addComponentType}
              coverpageThemeAction={this.props.coverpageThemeAction}
            />
          </Suspense>
        </div>
      </div>
    );
  };

  _addNewComponent = (
    component,
    rowIndex,
    colIndex,
    newRow,
    headerFooterType,
  ) => {
    if (component) {
      const addCommand = new AddComponentCommand({
        component,
        rowIndex,
        colIndex,
        newRow,
        headerFooterType,
        layout: [...this.props.layout],
        components: { ...this.props.components },
        docNo: this.props.docNo,
        docID: this.props.docID,
        mode: this.props.mode,
        addDocumentComponentAction: this.props.addDocumentComponentAction,
        addDealTableTab: this.props.addDealTableTab,
        removeComponentInDocument: this.props.removeComponentInDocument,
        updatePageBreakScrollViewAction:
          this.props.updatePageBreakScrollViewAction,
        autoUpdateTitle: this.props.autoUpdateTitle,
      });
      this.props.executeCommand(addCommand);
    }
  };

  _updateComponent = (
    updatedSection,
    addedNewTextSection,
    isMouseHover,
    oldSection,
    updateReduxAlso,
  ) => {
    const updateCommand = new UpdateComponentCommand({
      mode: this.props.mode,
      docID: this.props.docID,
      isTemplateTypeForm: this.props.isTemplateTypeForm,
      oldSection,
      isMouseHover,
      clickedActiveComponentId: this.props.clickedActiveComponentId,
      activeComponent: { ...this.props.activeComponent },
      updatedSection,
      updateDocumentComponentAction: this.props.updateDocumentComponentAction,
      updateSectionService: this._getComponentService("UPDATE"),
      addedNewTextSection,
      change: true,
      // updateDocumentClickedComponentID:
      //   this.props.updateDocumentClickedComponentID,
      forceUpdateEditorSectionIdAction:
        this.props.forceUpdateEditorSectionIdAction,
      toggleCoverpageView: this.props.toggleCoverpageView,
      updateActiveComponentMeta: this.props.updateActiveComponentMeta,
      coverpageThemeAction: this.props.coverpageThemeAction,
      coverpageThemeActionLabel: this.props.coverpageThemeActionData,
      updateReduxAlso,
    });
    this.props.executeCommand(updateCommand);
  };

  _enableAllSections = () => {
    // First remove disable from all sections
    document
      .querySelectorAll(".disable-component")
      .forEach(el => el.classList.remove("disable-component"));
  };

  _hideEditPane = () => {
    this._enableAllSections();
    this.props.updateAddComponentinToolbarAction(null);
    this.props.updateToolPaneData(false, "");
    this.props.updateDocumentClickedComponentID(null, true, null);
  };

  _onLoadPageNumberSidePane = () => {
    const { mode, isDocumentLocked } = this.props;
    if (isDocumentLocked) {
      return null;
    }
    return (
      <PageNumberListPane
        mode={mode}
        hideEditPane={this._hideEditPane}
        docID={this.props.docID}
        isDocumentLocked={this.props.isDocumentLocked}
      />
    );
  };

  _loadStripeSection = () => {
    const { mode, showForm } = this.props;
    return (
      <Suspense fallback="">
        <StripePaymentListPaneLazy
          mode={mode}
          hideEditPane={this._hideEditPane}
          setDraggedSection={this.props.updateDraggedSection}
          showForm={showForm}
        />
      </Suspense>
    );
  };

  render() {
    const {
      mode,
      addComponentType,
      sectionTriggerFrom,
      clickedActiveComponentType,
    } = this.props;
    if (
      sectionTriggerFrom &&
      sectionTriggerFrom !== this.state.prevTriggeredSection
    ) {
      this._onTriggeredSection();
    }

    if (
      addComponentType &&
      addComponentType === "HeaderFooter" &&
      clickedActiveComponentType === "PageNumber"
    ) {
      return (
        <div className="page-number-sidepane-container">
          {this._onLoadPageNumberSidePane()}
        </div>
      );
    }

    if (
      addComponentType &&
      addComponentType === "StripePayment" &&
      ((mode === "TEMPLATE" &&
        (!this.props.stripePaymentDetails ||
          (this.props.stripePaymentDetails &&
            !this.props.stripePaymentDetails.is_active))) ||
        mode !== "TEMPLATE")
    ) {
      return (
        <div className="stripe-payment-container">
          {this._loadStripeSection()}
        </div>
      );
    }

    const currentView = this._getPaneView() || this._addComponentPane();

    return currentView ? (
      <div className="components-wrapper animated fadeinright">
        {currentView}
      </div>
    ) : null;
  }
}

const mapStateToProps = (state, props) => {
  const { mode } = props;
  let docID;
  let docNo;
  let showDocumentDiffView = false;
  let showForm = false;
  let isTemplateTypeForm = false;
  let isDocumentLocked = false;
  let sectionTriggerFrom = null;
  let coverpageThemeActionData = null;
  let appliedCoverpageTheme = "Default";
  const {
    components,
    layout,
    clickedActiveComponentType,
    stripePaymentDetails,
    clickedActiveComponentId,
  } = state.DocumentStore;
  const { activeComponent } = state.EditorStore;
  if (mode === DOCUMENT) {
    const {
      document: {
        id,
        docNo: documentNo,
        showForm: showDocForm,
        template_type: typeOfTemplate,
        scope,
        stage,
      } = {},
      showDocumentDiffView: showDocumentDiffViewValue,
      sectionTrigger,
      coverpageThemeActionLabel,
    } = state.DocumentStore;
    coverpageThemeActionData = coverpageThemeActionLabel;
    sectionTriggerFrom = sectionTrigger;
    docID = id;
    docNo = documentNo;
    showDocumentDiffView = showDocumentDiffViewValue;
    showForm = showDocForm;
    isTemplateTypeForm =
      typeOfTemplate && typeOfTemplate.toUpperCase() === FORM;
    isDocumentLocked =
      !(scope && scope.write) || stage !== DOCUMENT_STATUS_HASMAP.DRAFT;
  } else if (mode === TEMPLATE) {
    const {
      template: {
        id,
        template_type: typeOfTemplate,
        is_locked: isLocked,
        status,
      },
      coverpageThemeActionLabel,
    } = state.TemplateStore;
    coverpageThemeActionData = coverpageThemeActionLabel;
    docID = id;
    docNo = id;
    isTemplateTypeForm =
      typeOfTemplate && typeOfTemplate.toUpperCase() === FORM;
    isDocumentLocked = isLocked || status !== DOCUMENT_STATUS_HASMAP.DRAFT;
  }
  const { addComponentType } = state.ToolPaneStore;

  // find coverpage
  const coverpageID = Object.keys(components).find(
    componentId =>
      components[componentId].content.section_type ===
        DOCUMENT_COMPONENT_TYPES.COVERPAGE ||
      components[componentId].content.type ===
        DOCUMENT_COMPONENT_TYPES.COVERPAGE,
  );
  let coverpageComponent = null;
  if (
    components &&
    components[coverpageID] &&
    components[coverpageID].content
  ) {
    coverpageComponent = components[coverpageID].content;
  }

  if (coverpageComponent && coverpageComponent.data) {
    appliedCoverpageTheme = coverpageComponent.data.attributes.appliedTheme;
  }

  return {
    docID,
    docNo,
    showDocumentDiffView,
    showForm,
    layout,
    components,
    isTemplateTypeForm,
    isDocumentLocked,
    sectionTriggerFrom,
    addComponentType,
    coverpageThemeActionData,
    coverpage: coverpageComponent,
    appliedCoverpageTheme,
    clickedActiveComponentType,
    stripePaymentDetails,
    clickedActiveComponentId,
    activeComponent,
  };
};

const mapDispatchToProps = {
  addComponentInDocument,
  addDealTableTab,
  updateDraggedSection,
  updateAddComponentinToolbarAction,
  updateDocumentSectionAction,
  toggleCoverpageView,
  coverpageThemeAction,
  addDocumentComponentAction,
  updateDocumentComponentAction,
  updateToolPaneData,
  updateDocumentClickedComponentID,
  executeCommand,
  removeComponentInDocument,
  nukeActiveEditor,
  undoComponentUpdate,
  forceUpdateEditorSectionIdAction,
  updateActiveComponentMeta,
  updatePageBreakScrollViewAction,
  autoUpdateTitle,
};

export default connect(mapStateToProps, mapDispatchToProps)(DocumentComponents);
